<template>
  <div class="official-site">
    <nav class="navbar">
      <div class="nav-container">
        <router-link to="/official/about" class="nav-logo">
          <img src="@/assets/image/eclub-logo-1-theme.png" alt="eClub" class="logo">
        </router-link>
        <ul class="nav-menu">
          <li class="nav-item">
            <router-link to="/official/about" class="nav-link">About</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/official/catalogue" class="nav-link">Features</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/official/news" class="nav-link">News</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/official/contact" class="nav-link">Contact</router-link>
          </li>
          <li class="nav-item" v-if="!isUserLoggedIn">
            <router-link to="/login" class="nav-link login-btn">Login</router-link>
          </li>
          <li class="nav-item user-menu" v-if="isUserLoggedIn">
            <div class="user-info">
              <span class="user-name">{{ userName }}</span>
              <router-link :to="systemLink" class="nav-link system-btn">Go to the System</router-link>
            </div>
          </li>
        </ul>
      </div>
    </nav>
    
    <main class="main-content">
      <router-view />
    </main>
    
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-content">
          <div class="footer-section">
            <h3>eClub</h3>
            <p>Your One-stop School Club System</p>
            <p>A platform of Extracurricular Activity Excellence International Pte. Ltd.</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; {{ currentYear }} eClub. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { isLoggedIn, getUserName, getUserType } from '@/utils/store'

export default {
  name: 'OfficialSiteLayout',
  data() {
    return {
      isUserLoggedIn: false,
      userName: '',
      userType: ''
    }
  },
  computed: {
    systemLink() {
      switch (this.userType) {
        case 'student':
          return '/home/studentclubs'
        case 'advisor':
          return '/home/adviserclubs'
        case 'schoolAdmin':
          return '/home/schoolclubs'
        case 'admin':
          return '/home/adminform'
        default:
          return '/home/studentclubs'
      }
    },
    currentYear() {
      return new Date().getFullYear()
    }
  },
  mounted() {
    this.checkLoginStatus()
    this.$root.$on('user-logged-in', this.checkLoginStatus)
    this.$root.$on('updateUserName', this.updateUserName)
  },
  beforeDestroy() {
    this.$root.$off('user-logged-in', this.checkLoginStatus)
    this.$root.$off('updateUserName', this.updateUserName)
  },
  methods: {
    checkLoginStatus() {
      this.isUserLoggedIn = isLoggedIn()
      if (this.isUserLoggedIn) {
        this.userName = getUserName() || 'User'
        this.userType = getUserType()
      }
    },
    updateUserName(newUserName) {
      this.userName = newUserName
    }
  }
}
</script>

<style scoped lang="scss">
.official-site {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.navbar {
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 100;
  
  .nav-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 70px;
  }
  
  .nav-logo {
    cursor: pointer;
    text-decoration: none;
    display: flex;
    align-items: center;
    
    .logo {
      height: 40px;
      width: auto;
    }
  }
  
  .nav-menu {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    align-items: center;
    gap: 30px;
  }
  
  .nav-link {
    text-decoration: none;
    color: #333;
    font-weight: 500;
    transition: color 0.3s ease;
    
    &:hover {
      color: #FF6B4A;
    }
    
    &.router-link-active {
      color: #FF6B4A;
    }
    
    &.login-btn {
      background: #FF6B4A;
      color: white;
      padding: 10px 20px;
      border-radius: 25px;
      transition: all 0.3s ease;
      
      &:hover {
        background: #e55a41;
        color: white;
      }
    }
    
    &.system-btn {
      background: #FF6B4A;
      color: white;
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 14px;
      transition: all 0.3s ease;
      margin-left: 10px;
      
      &:hover {
        background: #e55a41;
        color: white;
      }
    }
  }
  
  .user-menu {
    .user-info {
      display: flex;
      align-items: center;
      
      .user-name {
        color: #333;
        font-weight: 600;
        margin-right: 5px;
      }
    }
  }
}

.main-content {
  flex: 1;
}

.footer {
  background: #1a1a1a;
  color: white;
  padding: 40px 0 20px;
  
  .footer-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .footer-content {
    text-align: center;
    margin-bottom: 30px;
  }

  .footer-section {
    h3 {
      color: #FF6B4A;
      margin-bottom: 15px;
      font-size: 1.5rem;
    }

    p {
      color: #ccc;
      margin-bottom: 10px;
      font-size: 1rem;
    }
  }
  
  .footer-bottom {
    border-top: 1px solid #333;
    padding-top: 20px;
    text-align: center;
    color: #ccc;
  }
}

@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    height: auto;
    padding: 15px 20px;
  }
  
  .nav-menu {
    margin-top: 15px;
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
    
    .user-menu .user-info {
      flex-direction: column;
      gap: 8px;
      
      .nav-link.system-btn {
        margin-left: 0;
      }
    }
  }
}
</style>